export default "__VITE_ASSET__DtXEb7Mf__"